import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import "../fastparity/FastParity.css";
import RecordTapParity from "../parity/record/RecordTapParity";
import EveryOneTapParity from "../parity/order/OrderTapParity";
import "./Parity.css";
import Timer1 from "./Timer1";
import Bidcom from "../Bidcom";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:focus": {
      outline: "none",
    },
  },

  paper: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    border: "none",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: theme.shadows[5],

    "&:focus": {
      outline: "none",
    },

    position: "relative",
    borderRadius: "15px",
  },
}));
const Parity = ({
  data,
  setcreategame1,
  creategam,
  gettimeparity,
  biddataparity,
  bidhistoryparity,
  resultparity,
  disable,
  setdisable,
  resulthistoryparity
}) => {
  const classes = useStyles();
  const [refetch, setrefetch] = useState(false);
  const [bidvalue, setbidvalue] = useState("");
  const [color, setcolor] = useState("");
  const [open, setOpen] = useState(false);
  const [period, setperiod] = useState("")
  const [paritytype, setparitytype] = useState("parity");
 
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {

    setperiod(data ? data.period : "")
  }, [refetch, disable,data]);

  return (
    <>
      <div>
        <Modal
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <Bidcom
                bidvalue={bidvalue}
                color={color}
                paritytype={paritytype}
                period={data ? data.period : ""}
                setOpen={setOpen}
                bidhistoryparity={bidhistoryparity}
              />
            </div>
          </Fade>
        </Modal>
      </div>
      <div className="allcenter">
        <div className="scrollbar-indiv ">
          <div className="cenperiod">
            <div>
              <p className="per">Period</p>
              <p className="pernum">{data ? data.period : ""}</p>
            </div>
            <div>
              <p className="Cout">Count Down</p>
              <Timer1
                startingtime={data.startTime}
                currenttime={data.currentTime}
                setcreategame1={setcreategame1}
                creategam={creategam}
                gettimeparity={gettimeparity}
                setrefetch={setrefetch}
                refetch={refetch}
                setdisable={setdisable}
                resulthistoryparity={resulthistoryparity}
                onTimeOut={() => alert("ok")}
              />
            </div>
          </div>

          <div className="center-nav">
            <button
              onClick={() => {
                setbidvalue("Green");
                handleOpen();
                setcolor("green");
              }}
              disabled={disable ? true : false}
              className="over-btn"
            >
              <div>
                <div className={disable ? "join1disble" : "join1"}>
                  <span>Join Green</span>
                </div>
                <div className="blow">1:2</div>
              </div>
            </button>
            <button
              onClick={() => {
                setbidvalue("Violet");
                handleOpen();
                setcolor("rgb(102, 85, 211)");
              }}
              disabled={disable ? true : false}
              className="over-btn"
            >
              <div>
                <div className={disable ? "join1disble" : "voilet1"}>
                  <span>Join Violet</span>
                </div>
                <div className="blow">1:4.5</div>
              </div>
            </button>
            <button
              onClick={() => {
                setbidvalue("red");
                handleOpen();
                setcolor("Red");
              }}
              disabled={disable ? true : false}
              className="over-btn"
            >
              <div>
                <div className={disable ? "join1disble" : "red1"}>
                  <span>Join Red</span>
                </div>
                <div className="blow">1:2</div>
              </div>
            </button>
          </div>

          <div className="center-nav">
            <div>
              <div className="setnum-parity">
                <button
                  onClick={() => {
                    setbidvalue("1");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <div className={disable ? "tablenum1disble" : "tablenum1"}>
                    1
                  </div>
                </button>

                <button
                  onClick={() => {
                    setbidvalue("2");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <div className={disable ? "tablenum1disble" : "tablenum1"}>
                    {" "}
                    2
                  </div>
                </button>
                <button
                  onClick={() => {
                    setbidvalue("3");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <div className={disable ? "tablenum1disble" : "tablenum1"}>
                    {" "}
                    3
                  </div>
                </button>
                <button
                  onClick={() => {
                    setbidvalue("4");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                ></button>
                <div className={disable ? "tablenum1disble" : "tablenum1"}>
                  {" "}
                  4
                </div>
                <button
                  onClick={() => {
                    setbidvalue("5");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                ></button>

                <div className={disable ? "tablenum1disble" : "tablenum1"}>
                  {" "}
                  5
                </div>
              </div>
              <div className="setnum-parity">
                <button
                  onClick={() => {
                    setbidvalue("6");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <div className={disable ? "tablenum1disble" : "tablenum1"}>
                    {" "}
                    6
                  </div>
                </button>
                <button
                  onClick={() => {
                    setbidvalue("7");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <div className={disable ? "tablenum1disble" : "tablenum1"}>
                    {" "}
                    7
                  </div>
                </button>
                <button
                  onClick={() => {
                    setbidvalue("8");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <div className={disable ? "tablenum1disble" : "tablenum1"}>
                    {" "}
                    8
                  </div>
                </button>
                <button
                  onClick={() => {
                    setbidvalue("9");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <div className={disable ? "tablenum1disble" : "tablenum1"}>
                    {" "}
                    9
                  </div>
                </button>
                <button
                  onClick={() => {
                    setbidvalue("0");
                    handleOpen();
                    setcolor("");
                  }}
                  disabled={disable ? true : false}
                  className="over-btn"
                >
                  <div className={disable ? "tablenum1disble" : "tablenum1"}>
                    {" "}
                    0
                  </div>
                </button>
              </div>
              <div className="texttable">1:9</div>
            </div>
          </div>

          <RecordTapParity biddataparity={resultparity} period1={period} />
          <EveryOneTapParity biddataparity={biddataparity} />
        </div>
      </div>
    </>
  );
};

export default Parity;
